<form [formGroup]="form">
  <div fxLayout="column" class="form-content">
    <p>
      {{
        'booking.sdv.pricing-page.paragraph-1' | translate
      }}
    </p>
    <p>
      {{
        'booking.sdv.pricing-page.paragraph-2' | translate
      }}
    </p>
    <hr>

    <!-- Question #1 -->
    <label class="form-label">
      {{ 'booking.sdv.pricing-page.parental-data.label' | translate }}
    </label>

    <div
      fxLayout="column"
      fxLayoutGap="2rem"
      fxLayoutGap.gt-sm="0"
    >
      <div class="w-100 row align-items-end">
        <app-form-field-select
          class="col-6"
          [field]="parentOneControl"
          [options]="parentalRoleOptions"
        ></app-form-field-select>
        <app-form-field-select
          class="col-6"
          [field]="parentOneLevelOfEducationControl"
          [options]="parentalEducationLevelOptions"
          (selectionChange)="
            checkIfInformationIsCorrectRequired()
          "
          label="booking.sdv.pricing-page.parental-data.level-of-education.label"
        ></app-form-field-select>
      </div>

      <div class="w-100 row align-items-end">
        <app-form-field-select
          class="col-6"
          [field]="parentTwoControl"
          [options]="parentalRoleOptions"
        ></app-form-field-select>
        <app-form-field-select
          class="col-6"
          [field]="parentTwoLevelOfEducationControl"
          [options]="parentalEducationLevelOptions"
          (selectionChange)="
            checkIfInformationIsCorrectRequired()
          "
          label="booking.sdv.pricing-page.parental-data.level-of-education.label"
        ></app-form-field-select>
      </div>
    </div>

    <!-- Question #2 -->
    <app-form-field-radio
      [radioGroupClass]="'column-if-mobile'"
      class="w-100"
      [field]="receivesBafoegControl"
      [options]="radioBtnReceivesBafoegOptions"

      (change)="onBafoegChange()"
      label="booking.sdv.pricing-page.receives-bafoeg.question"
    >
    </app-form-field-radio>

    <!-- Question #3 -->
    <app-form-field-text
      *ngIf="isReceivesBafoeg"
      [field]="bafoegNumberControl"
      [errorMessages]="{
        pattern:
          'booking.sdv.pricing-page.receives-bafoeg.errorMessage'
      }"
      label="booking.sdv.pricing-page.receives-bafoeg.bafoegNumber"
    >
    </app-form-field-text>

    <!-- Question #3 -->
    <app-form-field-checkbox
      [field]="informationIsCorrectControl"
      label="booking.sdv.pricing-page.information-is-correct-label"
      [disabled]="informationIsCorrectControl.disabled"
    >
    </app-form-field-checkbox>
  </div>
</form>
